import { ref } from "vue";
import store from "@/store";
import router from "@/router";
import { adminAPI } from "@/laravel/config";

const putItem = async (table, id, val, destination, token) => {
  const res = ref(null);
  const err = ref(null);
  let endPoint = null;

  // checker
  if (destination) {
    // custom
    endPoint = destination;
  } else {
    // default
    endPoint = adminAPI;
  }

  try {
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(val),
    };

    // Add Authorization header only if token exists
    const authToken = token || store.state?.user?.token;
    if (authToken) {
      requestOptions.headers.Authorization = `Bearer ${authToken}`;
    }

    const response = await fetch(
      endPoint + `/${table}` + `/${id}`,
      requestOptions,
    );

    if (response.status === 401) {
      router.replace("/login");
      throw new Error("Unauthorized");
    }

    if (response.status === 403) {
      throw new Error("Forbidden");
    }

    if (response.status >= 500) {
      throw new Error("Server error");
    }

    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data?.error ||
          data?.message ||
          `Network response was not OK: ${response.status} ${response.statusText}`,
      );
    }

    res.value = data;
    
  } catch (error) {
    err.value = error.message;
  }

  return { res, err };
};

export default putItem;
